import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';
import { ConfigService } from '../../../services/config/config.service';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  constructor(
    public userService: UserService,
    private configService: ConfigService,
    private sanitizer: DomSanitizer,
  ) {}

  public companyMemberPhoneNumber = this.configService.getTextFromKey('phone-number-for-member');
  public companyPhoneNumber = this.configService.getTextFromKey('company-phone-number');
  public links: { name: string; route: string }[] = this.configService.get('footerLinks');
  public copyrightText = '';
  public footerAddressHtml!: SafeHtml;
  public baseUrl = environment.canonicalUrl;

  ngOnInit() {
    const currentYear = new Date().getFullYear();
    this.copyrightText = this.configService
      .get('copyrightText')
      .replace(/\{\{year}}|\[year]|%year%/gi, currentYear);
    this.footerAddressHtml = this.sanitizer.bypassSecurityTrustHtml(
      this.configService.get('footerAddress'),
    );
  }
}
